import { Action } from '@ngrx/store'
import * as PathSettingsTypes from './path-settings.types'

export class FetchPathSettingsRequest implements Action {
  readonly type = PathSettingsTypes.FETCH_PATH_SETTINGS_REQUEST
  constructor() {}
}

export class FetchPathSettingsSuccess implements Action {
  readonly type = PathSettingsTypes.FETCH_PATH_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchPathSettingsFailure implements Action {
  readonly type = PathSettingsTypes.FETCH_PATH_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdatePathSettingsRequest implements Action {
  readonly type = PathSettingsTypes.UPDATE_PATH_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdatePathSettingsSuccess implements Action {
  readonly type = PathSettingsTypes.UPDATE_PATH_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdatePathSettingsFailure implements Action {
  readonly type = PathSettingsTypes.UPDATE_PATH_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = PathSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = PathSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchPathSettingsSuccess
  | FetchPathSettingsFailure
  | FetchPathSettingsRequest
  | UpdatePathSettingsRequest
  | UpdatePathSettingsSuccess
  | UpdatePathSettingsFailure
  | SetDefaultData
  | UpdateField
